var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Customer-Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 9.5C5 8.90905 5.1164 8.32389 5.34254 7.77792C5.56869 7.23196 5.90016 6.73588 6.31802 6.31802C6.73588 5.90016 7.23196 5.56869 7.77792 5.34254C8.32389 5.1164 8.90905 5 9.5 5C10.0909 5 10.6761 5.1164 11.2221 5.34254C11.768 5.56869 12.2641 5.90016 12.682 6.31802C13.0998 6.73588 13.4313 7.23196 13.6575 7.77792C13.8836 8.32389 14 8.90905 14 9.5C14 10.6935 13.5259 11.8381 12.682 12.682C11.8381 13.5259 10.6935 14 9.5 14C8.30653 14 7.16193 13.5259 6.31802 12.682C5.47411 11.8381 5 10.6935 5 9.5Z",
    fill: "#A3AED0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.367 12.063C14.3441 12.1044 14.3369 12.1526 14.3466 12.1989C14.3564 12.2451 14.3824 12.2863 14.42 12.315C14.9411 12.7 15.5588 12.9328 16.2043 12.9875C16.8498 13.0422 17.4979 12.9167 18.0763 12.6249C18.6547 12.3331 19.1408 11.8864 19.4804 11.3347C19.82 10.783 19.9998 10.1479 19.9998 9.5C19.9998 8.85214 19.82 8.217 19.4804 7.66529C19.1408 7.11358 18.6547 6.66695 18.0763 6.37514C17.4979 6.08334 16.8498 5.9578 16.2043 6.0125C15.5588 6.06721 14.9411 6.30002 14.42 6.685C14.3824 6.71366 14.3564 6.75488 14.3466 6.80114C14.3369 6.84741 14.3441 6.89563 14.367 6.937C14.771 7.702 15 8.574 15 9.5C15 10.426 14.771 11.298 14.367 12.063Z",
    fill: "#A3AED0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.64101 15.7C5.87401 15.164 7.49101 15 9.50001 15C11.511 15 13.13 15.165 14.362 15.7C15.705 16.285 16.522 17.28 16.949 18.684C16.9952 18.8363 17.0051 18.9973 16.9779 19.1542C16.9507 19.311 16.8872 19.4593 16.7925 19.5872C16.6977 19.7151 16.5743 19.819 16.4322 19.8907C16.2901 19.9624 16.1332 19.9998 15.974 20H3.02801C2.86841 20.0001 2.71101 19.9628 2.56846 19.891C2.42591 19.8192 2.3022 19.715 2.20727 19.5867C2.11233 19.4584 2.04883 19.3096 2.02187 19.1523C1.9949 18.995 2.00523 18.8336 2.05201 18.681C2.48001 17.277 3.29701 16.283 4.64201 15.699L4.64101 15.7Z",
    fill: "#A3AED0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.819 14.0359C14.404 14.0619 14.38 14.6179 14.761 14.7839C15.803 15.2369 16.588 15.9039 17.151 16.7559C17.613 17.4549 18.33 17.9999 19.168 17.9999H20.948C21.655 17.9999 22.172 17.2969 21.923 16.6099C21.7722 16.1636 21.5306 15.7534 21.2134 15.405C20.8962 15.0567 20.5103 14.7778 20.08 14.5859C19.264 14.2059 18.243 14.0479 17.04 14.0009L17.02 13.9999H17C16.29 13.9999 15.55 13.9899 14.819 14.0359Z",
    fill: "#A3AED0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomer);
export default __webpack_public_path__ + "static/media/customer.e452f5935f0cfcbe681d217edc74a683.svg";
export { ForwardRef as ReactComponent };